/**
 * Panoul din dreapta e deschis pentru detaliul nodului SAU pentru formularul
 * de adaugare/editare. Daca stingeai panoul cand incepea editarea, formularul
 * plutitor (fara top/left) cadea sub panza si parea ca „Add to Inventory”
 * nu face nimic.
 */
export function panelOpen(selected: unknown, editing: unknown): boolean {
  return selected !== null && selected !== undefined
    ? true
    : editing !== null && editing !== undefined
}
